
import PreEntryApi from '../../assets/js/preentry'
import Uploader from './uploader'
import { i18nHelper } from '@it-common/lbp_common'
import OnboardHeader from '../OnboardHeader'
import LiAreaBankSelect from '../li_area_bank_select'
import $ from 'jquery'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Alert from 'vux/src/components/alert/index.vue'

export default {
components: {
XButton,
Group,
Cell,
XInput,
PopupRadio,
Search,
Loading,
Uploader,
Confirm,
OnboardHeader,
LiAreaBankSelect,
PopupPicker,
XDialog,
Alert
},
data () {
return {
bankImg: [],
delImageFlag: false, // 银行卡删除二次确认
resolveFalseDialog: false,
curIndex: -1, // 上传银行卡当前选中的图片下标
previewImg: '',
previewDialog: false,
defultBankAddress: {
bank_province_name: '',
bank_city: ''
},
select_bank_address: {
bank_province_id: 0,
bank_city_id: 0
},
submitName: this.$tsg('入职必备'),
no_bank_card: 1,
country_id: '47206',
is_first: true,
id: '',
isZH: localStorage.getItem('offer_zh') === 'zh',
action: '',
job_card_url: '',
showLoading: true,
job_card: [],
deleteRowsConfirm: false,
deleteCurIndex: '',
is_self_computer: '',
operating_system: '',
is_drive: '',
school: '',
major: '',
education: '',
degree: '',
study_style: '',
bank_card: '',
bank_card_info: '',
bank_city: '',
bank_card_info_state: 1,
work_schedules: '09:00:00-18:00:00',
computer_config: {
brand: '',
model: '',
processor: '',
memory: ''
},
car_info: [],
isSelfComputerItems: [
{ key: 1, value: '是' },
{ key: 2, value: '否' }
],
hasShowPopup: {
data: false
},
code: '',
is_intern: '',
is_blue_collar: '',
no_working: '',
job_type: '',
cityItems: [],
originalCityItems: [],
workSchedulesItems: [
{ key: '08:00:00-17:00:00', value: '08:00-17:00' },
{ key: '08:30:00-17:30:00', value: '08:30-17:30' },
{ key: '09:00:00-18:00:00', value: '09:00-18:00' }
],
bank_list: [],
bank_type: ''
}
},
created () {
this.id = this.$route.query.id


var localStorage = window.localStorage
this.code = localStorage.getItem('pre_code')
i18nHelper.loadLanguagePack(4159)
i18nHelper.setFixedLocale(localStorage.getItem('offer_zh'))
this.$forceUpdate()
this.postPsOption()

if (!this.code || !this.id) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}

PreEntryApi.checkLogin(
{ id: this.id, code: this.code },
() => {

},
err => {
this.showLoading = false
if (err === -2) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
},
() => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
},
() => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
)

PreEntryApi.getStaffDetail({ id: this.id, code: this.code }, data => {
if (data) {
this.country_id = data.country_id
}
})

PreEntryApi.getSubmitStatus({ id: this.id }, data => {
if (data) {
if ((data.is_intern === 1 && data.job_type === 2) || (data.no_working === 2 && data.job_type === 2)) {
this.submitName = this.$tsg('预览')
}
this.is_intern = data.is_intern
this.job_type = data.job_type
this.no_working = data.no_working
this.is_blue_collar = data.is_blue_collar
}
})

PreEntryApi.getMaterial({ id: this.id, code: this.code }, data => {
if (data) {
if (data.bank_card_url) {
this.bankImg = [{
url: data.bank_card_url
}]
}
this.job_card = data.job_card ? data.job_card : []
}
})

PreEntryApi.getStaffDetail({ id: this.id, code: this.code }, data => {
if (data) {
this.job_type = data.job_type
if (data.job_type === 1) {
this.work_schedules = '09:00:00-18:00:00'
}
}
})

PreEntryApi.getArea({ id: -1 }, (data, meta) => {
let res = []
if (data) {
data.forEach(function (item) {
res.push({
title: item.name,
other: item.id,
en_title: item.en_name
})
})
}
this.cityItems = res
this.originalCityItems = res
})

PreEntryApi.getSupplement(
{ id: this.id, code: this.code },
data => {
if (data) {
this.id = data.id
this.school = data.school
this.major = data.major
this.degree = data.degree
this.car_info = data.car_info
this.is_drive = data.is_drive
this.study_style = data.study_style
this.computer_config = data.computer_config
this.bank_card = data.bank_card
this.bank_card_info = data.bank_card_info
this.bank_city = data.bank_city
this.bank_type = data.bank_type ? data.bank_type : '招商银行'
this.is_self_computer = data.is_self_computer
this.operating_system = data.operating_system
this.work_schedules = data.work_schedules

this.defultBankAddress.bank_province_name = data.bank_province_name ? data.bank_province_name : ''
this.defultBankAddress.bank_city = data.bank_city ? data.bank_city : ''
this.select_bank_address.bank_province_id = data.bank_province_id ? data.bank_province_id : 0
this.select_bank_address.bank_city_id = data.bank_city_id ? data.bank_city_id : 0

this.$refs.setDefultBankAddress.getCaddress(this.defultBankAddress, this.select_bank_address)
if (!this.car_info) {
this.car_info = []
}

if (!this.computer_config) {
this.computer_config = {
brand: '',
model: '',
processor: '',
memory: ''
}
}

this.changeBankCardInfo()
}
this.showLoading = false
},
() => {
this.showLoading = false
},
() => {
this.showLoading = false
},
() => {
this.showLoading = false
}
)
},
mounted () {
$("input[type='file']").hide()
},
methods: {

addBankImg () {
const inputDom = document.getElementById('addInput')
inputDom.value = ''
inputDom.click()
},
preview (index) {
console.log(index, 'preview')
this.previewImg = this.bankImg[index].url
this.previewDialog = true
},
beforeDel (index) {
this.curIndex = index
this.delImageFlag = true
},

delBankImg () {
PreEntryApi.toDelBankCard({ id: this.$route.query.id, code: this.code }, data => {
this.bankImg = this.bankImg.filter((img, i) => i !== this.curIndex)
}, err => {
console.log(err)
})
},

imgChange (event) {
const file = event.target.files[0]
if (file.size > 4 * 1024 * 1024) {
this.$message.warning('上传文件最大为4MB')
event.target.value = ''
return
}
if (file) {
this.bankImg.push({
url: '',
status: true
})
const fd = new FormData()
fd.append('file', file)
PreEntryApi.toResolveBankCard({ id: this.$route.query.id, file: fd }, data => {
if (data.bank_card_url && data.bank_card_url.bank_card_type !== '0') {
this.bank_card = String(data.bank_card_url.bank_card_number).replace(/\s*/g, '')
if (data.pre_url) {
this.bankImg[0].url = data.pre_url
this.bankImg[0].status = false
} else {
this.bankImg = []
}
} else {
this.resolveFalseDialog = true
this.bankImg = []
}
}, err => {
console.log(err)
this.resolveFalseDialog = true
this.bankImg = []
})
}
},
getBankAreaId (val) {
this.select_bank_address = val
},
hasNoBankCard () {
this.no_bank_card = this.no_bank_card === 1 ? 2 : 1
},
changeBankCardInfo () {




this.bank_card_info_state = this.bank_card_info.trim().length === 0 ? 2 : 3

},
deleteRows (key) {
this.deleteRowsConfirm = true
this.deleteCurIndex = key
},
sendDel () {
this.car_info.splice(this.deleteCurIndex, 1)
this.sendMaterial(3)
},
uploadCard (field) {
this.$refs[field].UploadFileType()
},
returnFileData (res, field) {
this[field] = [res]
},
delImage (key, field) {
this.delImageItem.key = key
this.delImageItem.field = field
this.delImageFlag = true
},

sendDelImage () {
var field = this.delImageItem.field,
key = this.delImageItem.key

this.delImageItem = { key: '', field: '' }
this[field].splice(key, 1)

PreEntryApi.updateMaterialByField(
{
id: this.id,
fieldName: field,
field: this[field]
},
() => {
this.delImageFlag = false
}
)
},

getIsZh (data) {
var localStorage = window.localStorage
if (data) {
localStorage.setItem('offer_zh', 'zh')

} else {
localStorage.setItem('offer_zh', 'en')

}
this.isZH = data
},
showStep () {
this.hasShowPopup.data = !this.hasShowPopup.data
},
isDrive () {
if (this.is_drive === 1) {
if (!this.car_info.length) {
this.car_info.push({
number: '',
brand: '',
type: '废弃'
})
}
} else {
this.car_info = []
}
},
addEdu () {
if (this.car_info.length === 3) {
return false
}
this.car_info.push({
number: '',
brand: '',
type: '废弃'
})
},

sendMaterial (returnFlag) {
this.id = this.$route.query.id

this.computer_config = {
brand: '',
model: '',
processor: '',
memory: ''
}

if (this.is_drive === 1) {
if (!this.car_info) {
this.$message.error(this.$tsg('请输入您的车辆信息。'))
return false
}

var carInfo = []
this.car_info.forEach(function (item) {
if (item.number || item.brand || item.type) {
item.number = item.number.toUpperCase()
carInfo.push(item)
}
})
} else {
carInfo = ''
}
console.log(this.defultBankAddress)
console.log(this.select_bank_address)
if (this.defultBankAddress.bank_city === '' || this.defultBankAddress.bank_province_name === '' || this.select_bank_address.bank_city_id === 0 || this.select_bank_address.bank_province_id === 0) {
this.$message.error(this.$tsg('开户行所在城市必填'))
return false
}
if (this.work_schedules === '') {
this.$message.error(this.$tsg('请选择上下班时间'))
return false
}

PreEntryApi.saveSupplement(
{
id: this.id,
code: this.code,
is_self_computer: this.is_self_computer,
operating_system: this.operating_system,
is_drive: this.is_drive,
school: this.school,
major: this.major,
education: this.education,
bank_card: this.bank_card,
bank_card_info: this.bank_card_info,
degree: this.degree,
study_style: this.study_style,
computer_config: this.computer_config,
work_schedules: this.work_schedules,
bank_city: this.defultBankAddress.bank_city,
bank_province_name: this.defultBankAddress.bank_province_name,
bank_city_id: this.select_bank_address.bank_city_id,
bank_province_id: this.select_bank_address.bank_province_id,
car_info: carInfo,
bank_type: this.bank_type

},
data => {
if (data !== '') {
this.$message.error(this.$tsg('资料信息更新失败。'))
return false
}



if (returnFlag === 2) {
if ((this.is_intern === 1 && this.job_type === 2) || (this.no_working === 2 && this.job_type === 2)) {
this.$router.push({
name: 'onboard.preview',
query: { id: this.id }
})

} else {
this.$router.push({
name: 'onboard.certify',
query: { id: this.id }
})

}
} else if (returnFlag === 1) {
this.$router.push({ name: 'onboard.list', query: { id: this.id } })
} else if (returnFlag === 3) {

}
},
() => {
this.$message.error(this.$tsg('其他补充信息更新失败。'))

}
)
},
resultCityClick (item) {
this.bank_city = item.title
},
getCityResult (val) {
this.cityItems = this.originalCityItems
this.cityItems = this.cityItems.filter(item => {
return item.title.includes(val)
})
},
handleAvatarSuccess (res) {
if (res.code !== 0) {
this.$message.error(this.$tsg('上传失败。'))
return false
}

this[res.field + '_url'] = res.data.pre_url
},
postPsOption () {
PreEntryApi.postPsOption(
{},
(data, meta) => {
const bankObj = data['10'] || {}
this.bank_list = Object.keys(bankObj).map(key => ({
key: key,
value: bankObj[key]
}))

this.showLoading = false
},
err => {
this.$message.error(this.$tsg('选项数据获取失败。'))
this.showLoading = false
}
)
}
}
}



// WEBPACK FOOTER //
// ./src/components/onboard/supplement.vue